import { render, staticRenderFns } from "./ExtratoHeader.vue?vue&type=template&id=56e73716"
import script from "./ExtratoHeader.vue?vue&type=script&lang=js"
export * from "./ExtratoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports